export default __webpack_public_path__ + "static/media/extension-03.bbf7ea40.png";